import React from "react";
import PropTypes from "prop-types";
import { Button, Tabs } from "@sunwing/wvi-components";
import { ParagraphConnector } from "../ParagraphConnector";
import { Section } from "../../components/Section";
import { RCL } from "../../components/RCL";
import * as styles from "./DescriptionTabs.module.scss";

const DescriptionTabs = ({ overviewTab, travelTipsTab, hasMerchandisingData }) => {
	const _data = [];
	if (overviewTab) {
		_data.push({
			key: "overview",
			toggle: {
				label: {
					heading: RCL({ searchKey: "overview" }),
				},
			},
			panel: <ParagraphConnector data={overviewTab} />,
		});
	}
	if (travelTipsTab) {
		_data.push({
			key: "travelTips",
			toggle: {
				label: {
					heading: RCL({ searchKey: "travel-tips" }),
				},
			},
			panel: <ParagraphConnector data={travelTipsTab} />,
		});
	}

	const scrollToDealsSection = () => {
		const offset = 50;
		const element = document.querySelector("[data-promotion-deal]");
		if (!element) return;

		const elementPosition = element.getBoundingClientRect().top + window.scrollY;
		const targetPosition = elementPosition - offset;

		window.scrollTo({
			top: targetPosition,
			behavior: "smooth",
		});
	};

	return (
		<Tabs isSticky={false} defaultValue={_data[0].key} className={styles.tabList}>
			<div className={styles.tabListGroup}>
				{hasMerchandisingData && (
					<div className={styles.shopDealsButton} onClick={() => scrollToDealsSection()}>
						<Button
							className={styles.shopDealsButton}
							variant="action"
							icon="chevron-right"
							iconPlacement="right">
							{RCL({ searchKey: "shop-deals" })}
						</Button>
					</div>
				)}
				<div className={styles.tabListWrapper}>
					<Tabs.List backgroundColor={"grey"}>
						{_data.map(tab => (
							<Tabs.Trigger key={tab.title} value={tab.key} label={tab.toggle.label.heading}>
								{tab.toggle.label.heading}
							</Tabs.Trigger>
						))}
					</Tabs.List>
				</div>
			</div>
			{_data.map(tab => (
				<Tabs.Content key={tab.title} value={tab.key}>
					<Section>{tab.panel}</Section>
				</Tabs.Content>
			))}
		</Tabs>
	);
};

DescriptionTabs.propTypes = {
	overviewTab: PropTypes.object,
	travelTipsTab: PropTypes.object,
	thingsToDoTab: PropTypes.object,
	hasMerchandisingData: PropTypes.boolean,
};

DescriptionTabs.defaultProps = {
	overviewTab: null,
	travelTipsTab: null,
	thingsToDoTab: null,
	hasMerchandisingData: false,
};

export default DescriptionTabs;
export { DescriptionTabs };
